import { render, staticRenderFns } from "./NamePwdDialog.vue?vue&type=template&id=cddc496e&scoped=true"
import script from "./NamePwdDialog.vue?vue&type=script&lang=js"
export * from "./NamePwdDialog.vue?vue&type=script&lang=js"
import style0 from "./NamePwdDialog.vue?vue&type=style&index=0&id=cddc496e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddc496e",
  null
  
)

export default component.exports